import { CONFIGURATION_APIS, INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setWareHouseList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import { IWarehouseListResponse } from "@/api_framework/api_modals/Configuration";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
export const useWareHouseListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isOnboardWareHouseListInProgress",
        status: true,
      }),
    );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(`${CONFIGURATION_APIS?.WAREHOUSE_API?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IWarehouseListResponse>) => {
          if (res.data.status) {
            dispatch(setWareHouseList({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isOnboardWareHouseListInProgress",
                status: false,
              }),
            );
          } else {
            dispatch(
              setLoading({
                key: "isOnboardWareHouseListInProgress",
                status: false,
              }),
            );
            dispatch(setWareHouseList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          dispatch(
            setLoading({
              key: "isOnboardWareHouseListInProgress",
              status: false,
            }),
          );
          dispatch(setWareHouseList({ data: [] }));
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            //   toast.error("Error while fetching List details");
          }
          if (e.status === 400) {
            //   toast("Product records not found");
          }

          if (e.response.status === 500) {
            toast.error("Server error 500");
          }
        });
    } catch (e: any) {
      dispatch(
        setLoading({
          key: "isOnboardWareHouseListInProgress",
          status: false,
        }),
      );
      toast.error("Server Error: " + e.message);
      dispatch(setWareHouseList({ data: [] }));
    }
  }, [dispatch]);
  return { execute };
};
